import { faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Container, Copyright, Sns } from "./styles";

const { GATSBY_GIT_HUB } = {
  GATSBY_GIT_HUB: "https://github.com/headring/oreum-blog-gatsby",
};

const SNS_LIST = [
  {
    id: 1,
    name: "깃허브",
    href: `${GATSBY_GIT_HUB}`,
    icon: faGithub,
  },
];

const Footer = () => {
  return (
    <Container>
      <Copyright>Copyright 2022. Team Oreum all rights reserved.</Copyright>
      <Sns>
        {SNS_LIST.map((sns) => {
          const { id, name, href, icon } = sns;
          return (
            <li key={id}>
              <a href={href} target="_blank" rel="noreferrer" alt={name}>
                <FontAwesomeIcon icon={icon} fontSize={"22px"} />
              </a>
            </li>
          );
        })}
      </Sns>
    </Container>
  );
};

export default Footer;
